var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.5003 36.6666C28.4808 36.6666 34.9503 30.1971 34.9503 22.2166C34.9503 14.2361 28.4808 7.7666 20.5003 7.7666C12.5198 7.7666 6.05029 14.2361 6.05029 22.2166C6.05029 30.1971 12.5198 36.6666 20.5003 36.6666Z",
    fill: "#FF4378"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 22.9166C19.8167 22.9166 19.25 22.35 19.25 21.6666V13.3333C19.25 12.65 19.8167 12.0833 20.5 12.0833C21.1833 12.0833 21.75 12.65 21.75 13.3333V21.6666C21.75 22.35 21.1833 22.9166 20.5 22.9166Z",
    fill: "#FF4378"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3167 5.74998H15.6834C15.0167 5.74998 14.4834 5.21665 14.4834 4.54998C14.4834 3.88331 15.0167 3.33331 15.6834 3.33331H25.3167C25.9834 3.33331 26.5167 3.86665 26.5167 4.53331C26.5167 5.19998 25.9834 5.74998 25.3167 5.74998Z",
    fill: "#FF4378"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.e459c19541d173c972315cb9d5de48f5.svg";
export { ForwardRef as ReactComponent };